import styled, { css, DefaultTheme } from 'styled-components';
import media from 'styled-media-query';

type TypographyProps = {
  uppercase?: boolean;
  center?: boolean;
  italic?: boolean;
  light?: boolean;
  dark?: boolean;
  bold?: boolean;
  brand?: boolean;
  opacity?: number;
};

const typographyModifiers = {
  uppercase: () => css`
    text-transform: uppercase;
  `,
  center: () => css`
    text-align: center;
  `,
  italic: () => css`
    font-style: italic;
  `,
  light: (theme: DefaultTheme) => css`
    color: ${theme.text.primary};
  `,
  dark: (theme: DefaultTheme) => css`
    color: ${theme.secondary};
  `,
  bold: () => css`
    font-weight: bold;
  `,
  brand: (theme: DefaultTheme) => css`
    color: ${theme.primary};
  `,
};

const applyModifiers = ({
  uppercase,
  center,
  italic,
  light,
  dark,
  bold,
  brand,
}: TypographyProps) => css`
  ${({ theme }) => css`
    ${uppercase && typographyModifiers.uppercase()}
    ${center && typographyModifiers.center()}
    ${italic && typographyModifiers.italic()}
    ${light && typographyModifiers.light(theme)}
    ${dark && typographyModifiers.dark(theme)}
    ${bold && typographyModifiers.bold()}
    ${brand && typographyModifiers.brand(theme)}
  `}
`;

export const Heading = styled.h2<TypographyProps>`
  ${({ theme, ...props }) => css`
    color: ${theme.text.primary};
    font-size: ${theme.typography.sizes.xl};
    font-family: ${theme.typography.family.primary};
    line-height: ${theme.typography.lineHeight.md};
    font-weight: bold;
    margin-bottom: ${theme.spacing.sm};

    ${media.lessThan('medium')`
		font-size: ${theme.typography.sizes.md};
      margin-bottom: ${theme.spacing.lg};
    `}

    ${applyModifiers(props)};
  `}
`;

export const SubTitle = styled.h3<TypographyProps>`
  ${({ theme, ...props }) => css`
    color: ${theme.text.primary};
    font-size: ${theme.typography.sizes.lg};
    font-family: ${theme.typography.family.primary};
    font-weight: normal;
    line-height: ${theme.typography.lineHeight.md};
    margin-bottom: ${theme.spacing.sm};

    ${media.lessThan('medium')`
      font-size: ${theme.typography.sizes.md};
      line-height: ${theme.typography.lineHeight.base};
    `}

    ${applyModifiers(props)};
  `}
`;

export const Paragraph = styled.p<TypographyProps>`
  ${({ theme, opacity = 1, ...props }) => css`
    color: ${theme.text.secondary};
    font-size: ${theme.typography.sizes.base};
    font-family: ${theme.typography.family.primary};
    font-weight: 400;
    line-height: ${theme.typography.lineHeight.base};
    opacity: ${opacity};
    letter-spacing: 0.5px;
    margin-bottom: ${theme.spacing.sm};

    /* ${applyModifiers(props)}; */
  `}
`;

export const Anchor = styled.a<TypographyProps>`
  ${({ theme, ...props }) => css`
    color: ${theme.primary};
    font-size: ${theme.typography.sizes.sm};
    font-family: ${theme.typography.family.primary};
    font-weight: 400;
    transition: all 0.2s linear;
    text-decoration: underline;

    &:hover,
    &:focus {
      color: ${theme.primary};
    }

    ${applyModifiers(props)};
  `}
`;
